import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import UsersGrid from "./UsersGrid";
import { UserCompact } from "../../../types/types";
import Spinner from "../../../ui/Spinner/Spinner";


export const Users = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/users`);
  const [users, setUsers] = useState<UserCompact[]>([]);

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    setUsers(response.data as unknown as UserCompact[]);
    setLoading(false);
  }, [response]);


  function empty() {}


  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background px-6">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          {location.pathname == "/settings/participants/new" ? (
            <span className="text-2xl font-semibold">
              {t("adding_participant")}
            </span>
          ) : id ? (
            <span className="text-2xl font-semibold">
              {t("editing_participant")}
            </span>
          ) : (
            <span className="text-2xl font-semibold">{t("participants")}</span>
          )}
        </div>
      </div>
      {loading ? <Spinner /> : <Outlet context={[users, setUsers]} />}
    </div>
  );
};
